import React, { useEffect, useState } from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { FaChevronDown } from 'react-icons/fa';

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-10px); }
  60% { transform: translateY(-5px); }
`;

const ScrollIndicator = ({ containerId = 'content-container' }) => {
  const [showIndicator, setShowIndicator] = useState(true);

  useEffect(() => {
    // Create an observer for the bottom sentinel
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Hide indicator when bottom is visible
        setShowIndicator(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0,
      }
    );

    // Add a sentinel element at the bottom of the container
    const container = document.getElementById(containerId);
    if (container) {
      const sentinel = document.createElement('div');
      sentinel.id = 'scroll-sentinel';
      container.appendChild(sentinel);
      observer.observe(sentinel);

      return () => {
        if (sentinel.parentNode) {
          sentinel.parentNode.removeChild(sentinel);
        }
        observer.disconnect();
      };
    }
  }, [containerId]);

  // Check if content is scrollable
  useEffect(() => {
    const checkScrollable = () => {
      const container = document.getElementById(containerId);
      if (container) {
        const isScrollable = container.scrollHeight > (window.innerHeight + 100);
        setShowIndicator(isScrollable);
      }
    };

    // Check initially and on resize
    setTimeout(checkScrollable, 100);
    window.addEventListener('resize', checkScrollable);

    return () => window.removeEventListener('resize', checkScrollable);
  }, [containerId]);

  if (!showIndicator) return null;

  return (
    <Box
      position="fixed"
      bottom={{ base: 20, md: 8 }}
      left="50%"
      transform="translateX(-50%)"
      zIndex={99}
      cursor="pointer"
      display={{ base: 'block', md: 'block' }}
      onClick={() => window.scrollBy({ top: window.innerHeight / 2, behavior: 'smooth' })}
      _hover={{
        '& > *': {
          color: 'brand.500',
          transform: 'translateX(-50%) scale(1.1)',
        }
      }}
    >
      <Icon
        as={FaChevronDown}
        color="whiteAlpha.900"
        boxSize={{ base: 8, md: 8 }}
        animation={`${bounce} 2s infinite`}
        transition="all 0.3s"
        position="relative"
        left="50%"
        transform="translateX(-50%)"
        filter="drop-shadow(0 0 2px rgba(0,0,0,0.5))"
      />
    </Box>
  );
};

export default ScrollIndicator;
